import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { Status } from '../types';
import { LocalDate } from '../utils/local-date';
import type Site from './site';

@JsonApiResource({
  type: 'special-event-meal',
})
export default class SpecialEventMeal extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) startDate = new LocalDate();
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) endDate = new LocalDate().add(
    1,
    'd'
  );

  availableWeekDays: string = '1111111';
  @JsonApiProperty({ resolver: Number }) price: number = 0.0;
  status: Status = Status.NeedUpdate;

  @JsonApiRelationship('site') availableSites = new Array<Site>();
  getDateRange(): [LocalDate, LocalDate] {
    return [this.startDate, this.endDate];
  }

  constructor(
    id?: SpecialEventMeal['id'],
    startDate: SpecialEventMeal['startDate'] = new LocalDate(),
    endDate: SpecialEventMeal['endDate'] = new LocalDate(),
    availableWeekDays: SpecialEventMeal['availableWeekDays'] = '0000000',
    price: SpecialEventMeal['price'] = 0.0,
    availableSites: SpecialEventMeal['availableSites'] = new Array<Site>(),
    status: SpecialEventMeal['status'] = Status.NeedUpdate
  ) {
    super();
    this.id = id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.availableWeekDays = availableWeekDays;
    this.price = price;
    this.availableSites = availableSites;
    this.status = status;
  }
}
